import type React from 'react'
import { useEffect, useState } from 'react'
import { Document as PDFDocument, Page, pdfjs } from 'react-pdf'
import styled from 'styled-components'
import 'react-pdf/dist/Page/TextLayer.css'
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`
interface Props {
  file: string
  rotation?: number
  scale?: number
}

const ImgDocument = styled.img<{ rotation: number; scale: number }>`
  transform: scale(${props => props.scale}) rotate(${props => props.rotation}deg)
    ${props => {
      if (props.rotation === 90) {
        return 'translateY(-100%)'
      }

      if (props.rotation === 180) {
        return 'translateX(-100%) translateY(-100%)'
      }

      if (props.rotation === 270) {
        return 'translateX(-100%)'
      }
    }};
  transform-origin: top left;
  max-width: 100%;
`

const PDFDocumentStyle = styled.div`
  min-width: 0;

  .react-pdf__Document {
    min-width: 0;
  }
`

const LinkStyle = styled.a`
  cursor: pointer;
  text-decoration: underline;
`

const PreviewDocument: React.FC<Props> = ({ file, rotation = 0, scale = 1 }) => {
  const [numPages, setNumPages] = useState<number>(0)
  const [isPasswordProtected, setIsPasswordProtected] = useState<boolean>(false)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages)
  }

  useEffect(() => {
    setIsPasswordProtected(false)
  }, [file])

  if (file.includes('.pdf')) {
    return isPasswordProtected ? (
      <div>
        This document cannot be opened as it is password protected. If you know the
        password, click{' '}
        <LinkStyle onClick={() => window.open(file, '_blank')}>here</LinkStyle> to enter
        it and view the file.{' '}
      </div>
    ) : (
      <PDFDocumentStyle>
        <PDFDocument
          file={`${file}`}
          onLoadError={console.error}
          onLoadSuccess={onDocumentLoadSuccess}
          rotate={rotation}
          onPassword={() => setIsPasswordProtected(true)}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <>
              <Page
                renderAnnotationLayer={false}
                renderTextLayer
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={scale}
              />

              <hr />
            </>
          ))}
        </PDFDocument>
      </PDFDocumentStyle>
    )
  }

  return <ImgDocument src={file} scale={scale} rotation={rotation} />
}

export default PreviewDocument
